<template>
    <div class="max-w-500 mx-auto bg-mission-detail" data-cy="container_mission_main">
        <!-- <TopBar :title="'ไลฟ์สไตล์ สิทธิพิเศษ'" :isBack="false" /> -->
        <div class="max-w-500 mx-auto w-full h-full fixed left-0 right-0 bg-mission" :style="{'background-image': `url('${backgroundImg}')`}"></div>
        <div class="max-w-500 mx-auto relative z-10 pt-4">
            <div class="bg-point relative m-auto px-4">
                <div class="absolute -top-2.5 sm:left-1 m:left-2 w-32">
                    <img data-cy="img_mission_fish_welcome" :src="imgFishWelcome">
                </div>
                <div class="pl-8 pt-2">
                    <img class="img-point" data-cy="img_mission_point_bg" :src="bgPoint">
                </div>
                <div class="absolute top-8 left-0 right-0 py-3">
                    <div class="ml-14 text-center font-bold text-a-blue-2140a6" data-cy="text_mission_point_message"
                        :class="checkConditionDevice()" v-if="isShowPoint">
                        {{getPointMessage()}}
                    </div>
                </div>
            </div>
            <div class="px-4 pb-5" v-if="arrDashboardFGF.length > 0">
                <img class="w-full rounded-lg" data-cy="img_mission_fgf_banner" :src="arrDashboardFGF[0].imageUrl" @click="clickDashboard(arrDashboardFGF[0])">
            </div>
            <div class="pb-16">
                <div class="px-4" v-if="isShowCheckIn">
                    <div class="bg-checkin pt-2.5 pb-6 rounded-xl w-full m-auto relative" data-cy="container_mission_checkin" :style="{ '--bg-checkin-url': 'url(' + bgCheckIn + ')' }">
                        <MissionCheckin data-cy="component_mission_checkin" class="pt-4 pb-6" :isCheckIn="isCheckIn"
                                        :missionCheckin="missionCheckin"
                                        :missionValue="missionValue"
                                        :progressMission="progressMission"
                                        :imgProgress="imgProgress"
                                        :page="page" />

                        <div class="absolute left-0 right-0 bottom-8 m-auto text-center" v-if="!isComplete">
                            <div v-if="isPeriodMission || isNoBadgeItem" >
                                <button class="min-w-[180px] max-w-[200px] bg-a-gray-e0e0e0 font-bold text-16 sm-max:text-12 text-a-gray-b5b5b5 rounded-lg py-2.5 px-3" data-cy="btn_mission_checkin_coming_soon">
                                    {{lbl.mission.coming_soon}}
                                </button>
                            </div>
                            <div v-else>
                                <button class="min-w-[180px] max-w-[200px] bg-a-gray-e0e0e0 font-bold text-16 sm-max:text-12 text-a-gray-b5b5b5 rounded-lg py-2.5 px-3" data-cy="btn_mission_checkin_disabled" v-if="isCheckIn">
                                    {{lbl.mission.btn_msg_checkin}}
                                </button>
                                <button class="min-w-[180px] max-w-[200px] bg-a-blue-0064ff font-bold text-16 sm-max:text-12 text-white rounded-lg py-2.5 px-3" data-cy="btn_mission_checkin_enabled" @click="clickCheckIn()" v-else>
                                    {{lbl.mission.btn_msg_checkin}}
                                </button>
                            </div>
                        </div>
                        <div v-else class="absolute left-0 right-0 m-auto text-center" :class="localeCode == 1033 ? 'bottom-5':'bottom-8'">
                            <button class="min-w-[180px] max-w-[200px] bg-a-gray-e0e0e0 font-bold text-16 sm-max:text-12 text-a-gray-b5b5b5 rounded-lg py-2.5 px-3" data-cy="btn_mission_checkin_success">
                                {{`${lbl.mission.title_success} ${lbl.mission.msg_success}`}}
                            </button>
                        </div>
                    </div>
                    <!-- <div class="relative mt-2.5 mx-auto text-center">
                        <div>
                            <img v-if="isPeriodMission || isNoBadgeItem" class="bg-checkin mx-auto" src="../../../assets/bg/bg-checkin.png">
                            <img v-else class="bg-checkin mx-auto" src="../../../assets/bg/bg-checkin.png">
                        </div>
                        <div v-if="isComplete" class="absolute top-5 left-0 right-0 m-auto text-14 font-bold text-a-black-000000">
                            <div class="mb-2">{{lbl.mission.title_success}}</div>
                            <div>{{lbl.mission.msg_success}}</div>
                        </div>
                        <div v-else class="absolute top-7 left-0 right-0 m-auto text-12 font-bold z-10">
                            <div v-if="isPeriodMission || isNoBadgeItem" class="text-a-black-000000 text-14">
                                <div class="mb-1">{{lbl.mission.mission}}</div>
                                <div>{{lbl.mission.coming_soon}}</div>
                            </div>
                            <div v-else class="-mt-3">
                                <div class="text-a-black-000000 mb-2">{{lbl.mission.btn_title_checkin}}</div>
                                <div v-if="isCheckIn" class="bg-a-blue-f2f5ff rounded-full w-36 h-9 mx-auto">
                                    <div class="text-a-blue-c2cdf2 py-3 text-center">{{lbl.mission.btn_msg_checkin}}</div>
                                </div>
                                <div v-else class="bg-a-blue-2140a6 rounded-full w-36 h-9 mx-auto" @click="clickCheckIn()">
                                    <div class="text-a-white-ffffff py-3 text-center">{{lbl.mission.btn_msg_checkin}}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="px-4 pb-6 pt-8">
                    <TabMenuMission data-cy="component_mission_tab_menu"></TabMenuMission>
                </div>
            </div>
        </div>
        <!-- <div class="scroll-overlay w-full max-w-500 fixed bottom-0 left-0 right-0 py-2 mx-auto" v-if="!isBottom">
            <div class="absolute left-0 right-0 bottom-24 flex justify-center align-middle text-14 text-a-white-ffffff">
                {{ lbl.mission.scroll_down }} <img class="pl-1" src="@/assets/icon/ic-scroll-down.svg" />
            </div>
        </div> -->
        <MenuBar />
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
//import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuBar from '@/components/Layout/MenuBar/MenuBar.vue';
import MissionCheckin from '../component/MissionCheckin.vue';
import TabMenuMission from '../component/TabMenuMission.vue';
//service
import MissionService from '../service/MissionService.js';
import { SubDashboardConfigBuilder } from '@/core/Campaign/config/DashboardConfigModel.js';
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";


export default {
    name: "Mission",
    mixins: [AuthPageMixin, AuthStatusMixin, LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        //TopBar,
        MenuBar,
        MissionCheckin,
        TabMenuMission,
    },
    data: function() {
        return {
            backgroundImg: null,
            treasureBox: null,
            imgFishWink: null,
            isCheckIn: false,
            isComplete: false,
            missionCheckin: 0,
            missionValue: 0,
            progressMission: 0,
            imgProgress: 0,
            page: {},
            isShowCheckIn: false,
            dashboardMissionConfig: "bblprivilege_mission_checkin",
            isPeriodMission: true,
            // isShowPoint: false,
            isNoBadgeItem: false,

            gameDashboard: null,
            surveyDashboard: null,

            isBottom: false,
            tabActive: '',
            isTransactionSoon: false,

            //FGF
            dashboardFGFConfig: "bblprivilege_mission_friend",
            arrDashboardFGF: [],

            imgFishWelcome: null,
            bgPoint: null,
            bgCheckIn: null,
        }
    },
    created: async function() {
        this.tracking.screenName('mission');
        this.tracking.event('mission', 'view_mission', null, null);
        this.tracking.event('mission_checkin', 'mission_checkin', null, null);

        this.imgUrl();
        await this.getBackgroundImg();
        await this.getConfigBlob();
        
        //this.gameDashboard = await this.getGameDashboard();
        this.tabActive = this.$route.params.tab;
        // this.setScrollDown();
        this.getDashboardFGF();

    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    mounted: function(){
        // handle redirect back from game vue
        let isPass = this.$route.query?.isPass ?? null
        if(isPass != null){
            this.tracking.event('mission_game', isPass == '1' ? 'mission_game_win' : 'mission_game_failed', null, null)

            // remove query
            this.$router.replace({
                query: {}
            })
        }
    },
    methods: {
        getConfigBlob: function () {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.apiGetMissionConfig()
                    .subscribe({
                        next: (res) => {

                            // this.isShowPoint = res.mission.point;
                            resolve(res.mission.point);
                            this.modal.loadingModal.hide();
                        },
                        error: (err) => {
                            this.errorApi(err);
                            resolve(null);
                            this.modal.loadingModal.hide();
                        }
                    });
            });
        },
        getPointMessage: function () {
            var pointUnit = this.lbl.mission.point_unit + (this.userPoint > 1 && this.localeCode == 1033 ? 's' : '');
            return this.lbl.mission.you_have + " " + this.FilterNumberFormat(this.userPoint) + " " + pointUnit;
        },
        getBackgroundImg: function () {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.apiGetImgConfig()
                    .subscribe({
                        next: async (res) => {
                            var getConfig = ConfigManager.getBlobUrl();
                            this.backgroundImg = getConfig + res.backgroundImg;
                            this.treasureBox = getConfig + res.imgTreasureBox;
                            this.imgFishWink = getConfig + res.imgFish;
                            await this.getDashboardMissionCheckin();
                            await this.checkStatusCheckin();
                            await this.getBadge();
                            this.modal.loadingModal.hide();
                            resolve(res);
                        },
                        error: () => {
                            resolve(null);
                            this.modal.loadingModal.hide();
                        }
                    });
            });
        },

        getDashboardMissionCheckin: function() {
            return new Promise((resolve) => {
                var configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                var params = configBuilder.create().getParams();
                BzbsDashboard.apiGetSubDashboard(params, this.dashboardMissionConfig)
                    .subscribe({
                        next: (res) => {
                            if (res) {
                                for (var period of res) {
                                    if (period) {
                                        this.isPeriodMission = false;
                                    }
                                }
                            }
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },

        getDashboardFGF: function() {
            return new Promise((resolve) => {
                var configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                var params = configBuilder.create().getParams();
                BzbsDashboard.apiGetSubDashboard(params, this.dashboardFGFConfig)
                    .subscribe({
                        next: (res) => {
                            this.arrDashboardFGF = res;
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },

        clickDashboard: function(dashboard){
            if(!dashboard) return;

            const url = new URL(dashboard.url);
            this.$router.push(url.pathname);

            if (dashboard.type == 'link') {
                this.tracking.event('mission_bannerFGF', 'click_bannerFGF', '1' + '|' + dashboard.url, null);
            } else if (dashboard.type == 'campaign') {
                this.tracking.event('mission_bannerFGF', 'click_bannerFGF', '1' + '|' + dashboard.id, null);
            } else if (dashboard.type == 'cat') {
                this.tracking.event('mission_bannerFGF', 'click_bannerFGF', '1' + '|' + dashboard.cat, null);
            }
        },

        clickCheckIn: function() {
            return new Promise((resolve) => {
                this.tracking.event('mission_checkin', 'mission_submit_checkin', null, null);
                this.modal.loadingModal.show();
                MissionService.apiCheckIn()
                    .subscribe({
                        next: async (res) => {
                            if (res.success) {
                                await this.checkStatusCheckin();
                                await this.getBadge();
                                await this.getUpdatePoint();
                                this.modal.loadingModal.hide();
                            }
                            resolve(res.success);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        checkStatusCheckin: function() {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.apiCheckStatusCheckIn().subscribe({
                    next: (res) => {
                        if(res.code == '1904') {
                            this.isCheckIn = true;
                        }
                        this.modal.loadingModal.hide();
                        resolve(res);
                    },
                    error: (err) => {
                        if(err.code == '1904') {
                            this.isCheckIn = true;
                        }
                        this.modal.loadingModal.hide();
                        resolve(null);
                    }
                });
            });
        },
        getBadge: function() {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.getBadge('login').subscribe({
                    next: (res) => {
                        if (res.length > 0) {
                            res.filter( m => {
                                if (m.PartitionKey.indexOf('BBL_Mission_CheckIn') >= 0 && this.checkShowCheckinMission(m.StartDate, m.EndDate)) {
                                    this.missionCheckin = m.Missions[0].Current;
                                    this.missionValue = m.Missions[0].Value;
                                    this.isComplete = m.Missions[0].IsCompleted;
                                    this.progressBarMission();
                                }else{
                                    this.missionCheckin = 0;
                                    this.missionValue = 7;
                                    this.isNoBadgeItem = true;
                                }
                            });
                        }else{
                            this.missionCheckin = 0;
                            this.missionValue = 7;
                            this.isNoBadgeItem = true;
                        }
                        this.isShowCheckIn = true;
                        this.modal.loadingModal.hide();
                        this.calPage();
                        resolve(res);
                    },
                    error: (err) => {
                        this.errorApi(err);
                        resolve(null);
                        this.modal.loadingModal.hide();
                    }
                });
            });
        },
        getUpdatePoint: function() {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                BzbsProfile.getPoint().subscribe({
                    next: (res) => {
                        this.setUpdatePoint(res.points);
                        this.modal.loadingModal.hide();
                        resolve(res);
                    },
                    error: (err) => {
                        this.errorApi(err);
                        resolve(null);
                        this.modal.loadingModal.hide();
                    }
                });
            });
        },
        progressBarMission: function(){
            this.progressMission = (this.missionCheckin / this.missionValue) * 100;
            this.imgProgress = ((this.missionCheckin / this.missionValue) * 100) - 2;
        },
        calPage: function() {
            const itemPerPage = 7;
            const current = this.missionCheckin;
            const days = this.missionValue;

            const totalPage = Math.ceil(days / itemPerPage);
            var currentPage = Math.ceil(current / itemPerPage);

            return this.page = {
                        totalPage,
                        currentPage
                    }
        },
        checkShowCheckinMission: function(startdate, enddate){
            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(startdate);
            let end = DatetimeHelper.unixTimestampToDate(enddate);
            return (currentDate >= start && currentDate <= end);
        },
        setScrollDown: function() {
            window.onscroll = () => {
                const clientHeight = document.documentElement.clientHeight;
                const scrollHeight = document.documentElement.scrollHeight;
                const scrollTop = document.documentElement.scrollTop;

                if (scrollTop + clientHeight >= scrollHeight-28) {
                    this.isBottom = true;
                }else{
                    this.isBottom = false;
                }

            };
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            this.imgFishWelcome = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/img-fish-welcome@3x.png`;
            this.bgPoint = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission-point.png`;
            this.bgCheckIn = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-new-checkin.png`;
        },
        checkConditionDevice: function() {
            if (this.userPoint >= 100 && this.userPoint <= 9999) {
                return 'm-max-375:text-16 m-min-max-390:text-18 l:text-20';
            } else if (this.userPoint >= 10000 && this.userPoint <= 99999) {
                return 'm-max-375:text-14 m-min-max-390:text-16 l:text-18';
            } else {
                return 'm-max-375:text-18 text-20';
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.bg-mission-detail {
    //background-color: rgb(255, 253, 228);
    height: 100vh;
    .bg-mission {
        background-repeat: no-repeat;
        background-position: top center;
        background-size: cover;
        background-attachment: fixed;
    }
    .bg-point {
        .img-point {
            width: 100%;
            height: 101px;
            margin: auto;
        }
    }
    .bg-checkin {
        // max-width: 200px;
        width: 100%;
        // min-height: 288px;
        height: auto;
        background-image: var(--bg-checkin-url);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center bottom;
    }

    .bg-mission-item{
        min-height: 144px;
        background-image: linear-gradient(to right, #1a63c9 22%, #2140a6 65%);
    }

    .scroll-overlay{
        height: 205px;
        background-image: linear-gradient(to top, #000, rgba(84, 84, 84, 0));
    }
}
</style>
